export default __webpack_public_path__ + "media/99aa56ebec7852dc904b8b1a0f2deb51aced95134b29621f8476c04b16bdc53b.svg";